import React from 'react';
import PropTypes from 'prop-types';
import { Bastes } from './';

import { SPICES } from '../modules/constants';

function Nandinos({ modifiers, bastes, hideCalories, toggle }) {
    if (!modifiers.length || !bastes) {
        return null;
    }

    const baste = modifiers.find((item) => item.slug === 'choose-baste');
    //const side = modifiers.find((item) => item.slug === 'choose-side');
    //const drink = modifiers.find((item) => item.slug === 'choose-drink');
    //const dessert = modifiers.find((item) => item.slug === 'choose-dessert');
    //const drinkOrDesert = drink.options.concat(dessert.options);

    //console.log('baste', baste);
    // console.log('side', side);
    // console.log('drinkOrDessert', drinkOrDesert);
    return (
        <>
            {baste && (
                <Bastes
                    toggle={toggle}
                    baste={baste.options}
                    bastes={bastes}
                    nandinos={true}
                    title={SPICES}
                    hideCalories={hideCalories}
                />
            )}
        </>
    );
}

Nandinos.propTypes = {
    modifiers: PropTypes.array,
    bastes: PropTypes.array,
    hideCalories: PropTypes.bool,
    toggle: PropTypes.func
};

export { Nandinos };
